<template>
    <div class="mrt5" id="homeBox">
        <el-input  style="width: 15%" v-model="dzName" placeholder="请输入地区协议" clearable size="mini"></el-input>
        <el-select v-model="i_state" placeholder="类型"  size="mini" style="width:150px;margin-left: 10px"  @change="timesdata">
            <el-option
                    v-for="item in style"
                    :key="item.i_state"
                    :label="item.label"
                    :value="item.i_state">
            </el-option>
        </el-select>
        <el-button  icon="el-icon-search" circle  @click="searchData" size="mini" style="margin-left: 10px"></el-button>
        <el-button  @click="addDZ" :class="baseerp+'btn'" size="mini" style="margin-left: 10px"> 新增协议 </el-button>
        <!--<el-button class="marB10" @click="invalid" :class="baseerp+'btn'" size="mini" >已作废协议</el-button>
        <el-button class="marB10" @click="effect" :class="baseerp+'btn'" size="mini">生效协议</el-button>-->
        <el-table
                class="mrt5"
                ref="table"
                size="mini"
                :height="tableHeight"
                border
                :data="tableData"
                style="width: 100%"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                @row-click="rowClick"
                :highlight-current-row="highlightCurrentRow">
            <el-table-column
                    :label="$t('form_serial_number')"
                    align="center"
                    type="index">
            </el-table-column>
            <el-table-column
                    align="center"
                    label="大区名"
                    prop="vc_region" show-overflow-tooltip>
            </el-table-column>
            <!--<el-table-column
                    align="center"
                    label="目的地"
                    prop="vc_lruname">
            </el-table-column>-->
            <el-table-column
                    align="center"
                    label="合同编号"
                    prop="vc_code" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="我方公司"
                    prop="vc_company" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="运输公司"
                    prop="vc_khname" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="开始时间"
                    prop="dt_starttime" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="结束时间"
                    prop="dt_endtime" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="录入人员"
                    prop="vc_lruname" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="录入时间"
                    prop="dt_createtime" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="状态"
                    :formatter="Status"
                    prop="i_state" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="file_name"
                    label="附件"
                    width="50">
                <template slot-scope="scope">
                    <a
                            :download="scope.row.filename"
                            mce_href="#"
                            :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+scope.row.filenewname+dbAgreement+'\'}','utf-8')">
                        <!--                        {{scope.row.file_name}}-->
                        <i class="el-icon-paperclip" v-show="scope.row.filename"></i>
                    </a>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="300" align="center">
                <template slot-scope="scope">
                    <el-button style="" size="mini" type="text" @click.stop="examine(scope.row)" :disabled="scope.row.i_state==1?false:true">审核</el-button>
                    <el-button style="" size="mini" type="text" @click.stop="details(scope.row)">编辑运费</el-button>
                    <el-button style="color: #e8c161;" size="mini" type="text" @click.stop="mbData(scope.row)">编辑模板</el-button>
                    <el-button style="" size="mini" type="text" @click.stop="warehouseM(scope.row)">仓库管理</el-button>
                    <el-button style="color: red;" size="mini" type="text" @click.stop="deleteData(scope.row,scope.$index)">{{$t('button_nullify')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                class="fr page"
                style="margin-top: 10px;text-align: right"
                background
                layout="prev, pager, next"
                @current-change="pageCurrentChange"
                :current-page.sync="currentPage"
                :total="tableTotal"
                :page-size="pageSize">
        </el-pagination>
        <!--<el-pagination  style="margin-top: 10px;text-align: right"
                        background
                        @current-change="pageCurrentChange"
                        layout="total,prev, pager, next"
                        :current-page.sync="currentPage"
                        :total="total">
        </el-pagination>-->
        <div :class="baseerp+'div'">
            <!--<el-dialog :title="title"
                       width="95%"
                       top="30px"
                       v-if="dialogTableVisible"
                       :visible.sync="dialogTableVisible"
                       :modal-append-to-body="false"
                       :close-on-click-modal="false">
                <add-dialog :add="add" @close="close" @getTrader="getTrader"></add-dialog>
            </el-dialog>-->
            <el-dialog :title="title"
                       width="550px"
                       v-if="dialogTableVisible"
                       :visible.sync="dialogTableVisible"
                       :modal-append-to-body="false"
                       :close-on-click-modal="false">
                <start-place :addSP="addSP" @close="close" @getAgreementList="getAgreementList"></start-place>
            </el-dialog>
            <el-dialog :title="title"
                       width="80%"
                       v-if="dialogTableVisibleW"
                       :visible.sync="dialogTableVisibleW"
                       :modal-append-to-body="false"
                       :close-on-click-modal="false">
                <warehouse-m :warehouse="warehouse" @closeW="closeW"></warehouse-m>
            </el-dialog>
            <el-dialog :title="title"
                       width="90%"
                       top="50px"
                       v-if="dialogTableVisiblebj"
                       :visible.sync="dialogTableVisiblebj"
                       :modal-append-to-body="false"
                       :close-on-click-modal="false">
                <change-place :bjSP="bjSP" @closebj="closebj" @getAgreementList="getAgreementList"></change-place>
            </el-dialog>
            <el-dialog :title="title"
                       width="400px"
                       v-if="dialogTableVisiblemb"
                       :visible.sync="dialogTableVisiblemb"
                       :modal-append-to-body="false"
                       :close-on-click-modal="false">
                <mb-edit :bjmb="bjmb" @closemb="closemb"></mb-edit>
            </el-dialog>

            <el-dialog title="确认审核"
                       class="check"
                       v-if="checkdialog"
                       :visible.sync="checkdialog"
                       :modal-append-to-body="false"
                       :close-on-click-modal="false">
                <el-input  v-model="opinion" placeholder="审核意见" style="width: 100%"> </el-input>
                <div slot="footer"  class="dialog-footer" style="text-align: center">
                    <el-button type="primary" @click="sure(4)"   :class="baseerp+'btn'"  size="mini">同意</el-button>
                    <el-button size="mini" @click="sure(-2)">不同意</el-button>
                </div>
            </el-dialog>
            <el-dialog
                    width="90%"
                    height="800"
                    :title="title"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="dialogVisible">
                <sheet-data :sheet="sheet" @close="cancelDialog" @getAgreementList="getAgreementList"></sheet-data>
            </el-dialog>
            <!--表报 -->
            <div class="">
                <reportdialog  ref="mydialog"   ></reportdialog>
                <eDialog ref="eDialog" :activePage="activePage"></eDialog>
            </div>

        </div>
    </div>

</template>

<script>
    import * as API from  "./api";
    import {baseerp} from "@/utils/baseUrl";
    import {baseApp} from "@/utils/baseUrl";
    import {file_url} from "@/utils/baseUrl";
    import {baseVersion} from "@/utils/baseUrl";
    import {filerequest_url} from './api';
    import {mapActions} from "vuex";
    import StartPlace from "./components/StartPlace";
    import ChangePlace from "./components/ChangePlace";
    import WarehouseM from "./components/WarehouseM";
    import MbEdit from "./components/MbEdit";
    import SheetData from "./SheetData";
    import reportdialog from "@/components/dialog"; // 错误dialog
    import eDialog from "@/components/eDialog"; // dialog
    export default {
        name: 'ProductOnSale',
        components: {MbEdit, WarehouseM, ChangePlace, StartPlace,SheetData,reportdialog,eDialog},
        data(){
            return{
                activePage:"report/res/spread.vue",
                dbAgreement:',dbAgreement',
                file_url: "",
                baseApp:"",
                baseVersion:"",
                token:"",
                i_uid:"",
                dialogVisible:false,
                sheet:{},
                nowdate:"",
                opinion:"",
                checkdialog:false,
                /*style: [ {
                    i_state: 3,
                    label: '全部'
                },{
                    i_state: 0,
                    label: '未审核'
                }, {
                    i_state: 1,
                    label: '审核通过'
                }, {
                    i_state: -2,
                    label: '审核不通过'
                }, {
                    i_state: -1,
                    label: '作废'
                }],*/
                style: [ {
                    i_state: 5,
                    label: '全部'
                },{
                    i_state: 3,
                    label: '审批中'
                },{
                    i_state: 0,
                    label: '待提交'
                }, {
                    i_state: 1,
                    label: '审批通过'
                }, {
                    i_state: -2,
                    label: '审批不通过'
                }, {
                    i_state: -1,
                    label: '作废'
                }, {
                    i_state: 4,
                    label: '线路审核通过'
                }],
                pageSize:15,
                currentPage:1,
                tableTotal:0,
                dzName:"",
                baseerp:'',
                tableHeight:0,
                dialogTableVisible:false,
                dialogTableVisiblebj:false,
                dialogTableVisiblemb:false,
                dialogTableVisibleW:false,
                addSP:{},
                bjSP:{},
                bjmb:{},
                warehouse:{},
                title:"",
                tableData:[
                    // {dt_createtime:2022}
                ],
             //   pageSize:1,
                //currentPage:1,
                //total:0,
                i_state:5,
                state:[],
                highlightCurrentRow:false,

            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.token=sessionStorage.getItem('token');
            this.i_uid=sessionStorage.getItem('userid');
            //console.log(this.file_url,this.baseApp,this.i_uid,this.token,this.baseVersion,"zzzzzzzzzzzzzzzzzzzzz");
            this.state=[0,1];
            this.getAgreementList(this.state);
            this.getDateYYYYMMddHHMMSS();
            this.$nextTick(function () {
                this.onResize();

            });
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            heightAuto(){
                //console.log(".....................")
                this.tableHeight = window.innerHeight - this.$refs.table.$el.clientTop - 280;
            },
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80

                //console.log(this.tableHeight,"????????????????")
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            //关闭dialog
            cancelDialog(){
                if (this.title=="统计报表"){
                    this.dialogVisible=false;
                    this.highlightCurrentRow=true;
                }
            },

            timesdata(val){
                if (val==5){
                    this.currentPage=1;
                    this.state=[0,1];
                    //this.getAgreementList(this.state);
                }else{
                    // console.log("val",val);
                    this.currentPage=1;
                    //console.log("state",this.state);
                    this.state=[];
                    this.state.push(val);
                    // console.log("state1",this.state);
                    //this.getAgreementList(this.state);
                }

            },

            //获取已挂牌列表
            async getAgreementList(state,pageSize){
                // console.log("state",state,"pageSize",pageSize);
                if (state==0){
                    this.i_state=0;
                    // console.log(this.i_state,"i_state");
                }
                if(pageSize!=undefined) {
                    this.currentPage=pageSize;
                }
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id);
                } else {
                    this.mid = sessionStorage.getItem('mids');
                }
                let params={
                    vc_region:this.dzName,
                    pageStart:this.currentPage,
                    pageSize:15,
                    i_mid:this.mid,
                    i_stateList:state,
                };
                // console.log(params,"params");
                let res=await API.getAgreementList(params);
                if(res.code==1){
                    this.tableData=res.list;
                    this.tableTotal=res.count;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },
            searchData(){
                //this.pageSize=1;
                //this.currentPage=1;
                // console.log("this.state",this.state,"this.opinion",this.opinion,"this.currentpage",this.currentPage)
                this.getAgreementList(this.state);
            },
            invalid(){
                this.i_state=-1;
                this.getAgreementList(this.i_state);
            },
            effect(){
                this.i_state=1;
                this.getAgreementList(this.i_state);
            },
            addDZ(){
                this.title="新增协议";
                this.addSP={
                    title:"新增"
                };
                this.dialogTableVisible=true;
            },
            //拿到当前行数据
            rowClick(row){
                this.title="编辑协议";
                this.highlightCurrentRow=true;
                this.addSP={
                    i_id:row.i_id,
                    row:row,
                    title:"编辑"
                };
                this.dialogTableVisible=true;
                //console.log(row,"row");

            },

            examine(row){
                /*this.opinion="";
                this.checkdialog=true;
                // console.log("row",row);
                this.i_state=row.i_state;
                this.ID=row.i_id;*/

                /*this.dialogVisible=true;
                this.title="统计报表";
                this.sheet={
                    i_state:row.i_state,
                    ID:row.i_id,
                    value:row,
                }*/

            //    this.fileindex=index;
            //    console.log(this.fileindex,"this.fileindex");
                //    this.highlightCurrentRow=true;
                //    this.title="统计报表";
                this.sheet={
                    i_state:row.i_state,
                    ID:row.i_id,
                    value:row,
                };
                //console.log(this.sheet,"sheeettttt");
            //    this.fileId=this.sheet.value.fileId;

                let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});
                //this.$refs.eDialog.showDialog({title:"报表",btn:{f:this.btn,l:{a:{title:"a",name:"a1"}}},parm:{type:'AttMonthRpt',mid:this.$route.meta.mid},w:800,h:600});
                document.addEventListener('click',function(e){
                    loading.close()
                })

                //console.log(this.mid,"midddddddddd==681?");
                this.$refs.eDialog.showDialog({title:"统计报表",btn:{f:this.saveorsubmit,l:{a:{title:"审核",name:"a1"}}},parm:{type:'freightRpt',mid:this.mid,arg:{dbid:row.i_id}},w:1024,h:768});

                loading.close();
            },

            saveorsubmit(a){
                //console.log(a,'111111');
                if(a=="a1"){
                    //console.log("保存");
                    //console.log(this.sheet.value);
                    // return;
                    this.checkdialog=true;
                    /*//console.log(this.$refs.eDialog,"spd.excelIo111");
                    //console.log(this.$refs.eDialog.$refs.component_ref,"spd.excelIo222");
                    console.log(this.$refs.eDialog.$refs.component_ref.spread,"spread");
                    var json = this.$refs.eDialog.$refs.component_ref.spread;
                    var ex = this.$refs.eDialog.$refs.component_ref.excelIo;
                    json = json.toJSON({includeBindingSource:true});
                    const that=this;
                    ex.save(json, async function (blob) {
                        //console.log(blob,"blob");
                        FaverSaver.saveAs(blob, 'export.xlsx');
                        //console.log(that.cTime+that.gsName+that.cjName+that.filename+".xls","fileeeeeeee");
                        let newFiles = new window.File([blob], that.sheet.value.dt_createtime+that.sheet.value.vc_gsname+that.sheet.value.vc_cjname+that.filename+".xls", {type: 'xls'});
                        let param = {
                            "IDtype": "",
                            "style": "settlementReport",
                            files:newFiles,
                            i_appid:0,
                            vc_app: "settlementReport",
                        };
                        //console.log(param,"param");
                        let res = await API.upload(param);
                        if (res.code == 1) {
                            that.fileId=res.data[0].i_id;
                            that.file_name=res.data[0].filename;
                            that.filenewname=res.data[0].filenewname;
                            //console.log(that.fileId,that.file_name,that.filenewname,"res.data")
                            ///调保存接口
                            that.updStatistics();
                            //that.$message.success(res.message);
                        } else if (res.code == -2) {
                            that.$router.push('/login');
                            that.$message.error(res.message);
                        }else{
                            that.$message.error(res.message);
                        }
                    }, function (e) {
                        //console.log(e,"12345")
                    });
                    //console.log(ex.save,"save");*/



                }
            },

            sure(val){
                // console.log(this.opinion,"opinion");
                this.auditAgreement(val);
            },

            //审核大包协议
            async auditAgreement(val){
                let params={
                    i_mid:this.mid,
                    i_state:val,
                    i_id:this.sheet.ID,
                    vc_checknote:this.opinion,
                   //dt_checktime:this.nowdate,
                };
                let res=await API.auditAgreement(params);
                if(res.code==1){
                    //this.$message.success(res.message);
                    this.opinion="";
                    this.checkdialog=false;
                    this.$refs.eDialog.onReset();
                    this.$refs.eDialog.dialogVisible=false;
                //    console.log(this.currentPage,"currentpage");
                    let state=[];
                    state.push(val);
                    this.i_state=val;
                    this.getAgreementList(state,this.currentPage);
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
                /*this.$confirm('确定审核通过该协议?', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });*/
            },

            details(row){
                //console.log(this.currentPage,"currentPage",this.i_state,"i_state");

                this.bjSP={
                    value:row,
                    currentPage:this.currentPage,
                    state:this.i_state,
                };
                this.title='编辑运费--'+this.bjSP.vc_region;
                this.dialogTableVisiblebj=true;
            },
            mbData(row){
                this.title="编辑模板";
                this.dialogTableVisiblemb=true;
                this.bjmb=row;

            },
            warehouseM(row){
                this.title="仓库管理";
                this.dialogTableVisibleW=true;
                this.warehouse=row;
            },
            deleteData(row,index) {
                this.$confirm('确定作废该协议?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    let params = {
                        i_id: row.i_id,
                        validateCode: row.validateCode,
                        validateKeynames: row.validateKeynames,
                        busType: row.busType,
                        table: row.table,
                        dt_createtime: row.dt_createtime,
                        uid:row.uid,
                    };
                    let res = await API.deleteAgreement(params);
                    if (res.code == 1) {
                        this.tableData.splice(index, 1)
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                })
            },
            close(){
                this.dialogTableVisible=false;
            },
            closebj(){
                this.dialogTableVisiblebj=false;
            },
            closemb(){
                this.dialogTableVisiblemb=false;
            },
            closeW(){
                this.dialogTableVisibleW=false;
            },
            pageCurrentChange(val){
                //this.pageSize=val;
                // console.log(this.state,"state");
                this.currentPage=val;
                this.getAgreementList(this.state)
            },
            Status(row, column, cellValue, index){
               /* if(row.i_state==0){
                    return '未审核'
                }else if(row.i_state==1){
                    return '审核通过'
                }else if(row.i_state==-2){
                    return '审核失败'
                }else if(row.i_state==-1){
                    return '作废'
                }*/
                if(row.i_state==0){
                    return '待提交'
                }else if(row.i_state==3){
                    return '审核中'
                }else if(row.i_state==1){
                    return '审批通过'
                }else if(row.i_state==-1){
                    return '作废'
                }else if(row.i_state==-2){
                    return '审批不通过'
                }else if(row.i_state==4){
                    return '线路审核通过'
                }
            },

            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                const hour = date.getHours().toString().padStart(2, '0');
                const min = date.getMinutes().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.nowdate=`${date.getFullYear()}-${month}-${strDate} ${hour}:${min}`;
                // console.log(this.nowdate,"this.nowdate");
            },

        },
        beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto)
        },
    }
</script>

<style lang="scss">

    .check .el-dialog{
        min-width: 500px;
    }

    .mrt5{
        margin-top: 5px;
    }
    .flex{
        display: flex;
        align-items: center;
    }
    .el-dialog{
        min-width: 700px;
    }
    .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
    }
    .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
        margin-bottom: 8px;
    }
</style>